import React from "react";
import Link from "@amzn/awsui-components-react/polaris/link";
import type { LinkProps } from "@amzn/awsui-components-react/polaris/link";

/**
 * HardLink is a direct wrapper around the Cloudscape Link component. It maintains all the functionality/API of
 * the base Cloudscape Link component and performs standard browser navigation with full page reloads.
 *
 * @see {@link https://cloudscape.design/components/link/?tabId=api|AWS Cloudscape Link API}
 */
export const HardLink: React.FC<LinkProps> = (props) => {
  return <Link {...props} />;
};
